import React from 'react';

const Filters = () => {
    return (
        <>
            <div className="search-product--filter">
                <h3 className='h3'>Select Filters</h3>
                <div className="search-product--filter-group mb-4">
                    <h4 className='h4'>Cab Type</h4>
                    <ul className='search-product--filter-group-list '>
                        <li><input type="checkbox" /> Hatchback</li>
                        <li><input type="checkbox" /> Sedan</li>
                        <li><input type="checkbox" /> SUV</li>
                    </ul>
                </div>
                {/* <div className="search-product--filter-group mb-4">
                    <h4 className='h4'>Fuel Type</h4>
                    <ul className='search-product--filter-group-list'>
                        <li><input type="checkbox" /> Petrol</li>
                        <li><input type="checkbox" /> Diesel</li>
                    </ul>
                </div> */}
                <div className="search-product--filter-group mb-4">
                    <h4 className='h4'>Vehicle Model</h4>
                    <ul className='search-product--filter-group-list '>
                        <li><input type="checkbox" /> Maruti Suzuki Ertiga</li>
                        <li><input type="checkbox" /> Toyota Innova</li>
                        <li><input type="checkbox" /> Innova Crysta</li>
                    </ul>
                </div>
                
            </div>
        </>
    )
}
export default Filters